const Settings = require('./domain/settings'),
	adManager = require('./services/adManager'),
	breakpoints = require('../services/breakpoints'),
	sizeMappings = require('../services/sizeMappings'),
	slotManager = require('./services/slotManager'),
	refreshManager = require('./services/refreshManager'),
	hooks = require('../utils/hooks'),
	cmd = require('../utils/cmd'),
	pubsub = require('../utils/pubsub'),
	lazyLoadService = require('../services/lazyLoadService'),
	closeableAdManager = require('../services/closeableAdManager'),
	perf = require('../utils/performance');

require('./services/messaging');
require('../utils/debug');

let settings = null;

if (window.advert && typeof window.advert.init === 'function') {
	throw new Error('[ADVERT] web advertising script already loaded');
}

async function init(config, userHooks) {
	cmd.reject('loaded');

	const {
		'dfp': dfpConfig
	} = config;

	_coreInit(userHooks);

	await _dfpInit(dfpConfig);

	cmd.accept('loaded');
}

function _coreInit(userHooks = {}) {
	perf.mark('core - initialisation - start');

	hooks.init(userHooks);
	window.advert.addHook = hooks.add;
	window.advert.removeHook = hooks.remove;

	perf.mark('core - initialisation - end');
}

async function _dfpInit(config) {
	perf.mark('dfp - initialisation - start');

	settings = new Settings(config);

	breakpoints.init(settings);
	sizeMappings.init(settings);
	refreshManager.init(settings);
	lazyLoadService.init(settings);
	await adManager.init(settings);
	await slotManager.init(settings);
	closeableAdManager.init(slotManager);

	pubsub.publish('settings.changed');

	perf.mark('dfp - initialisation - end');
}

const initialCmds = window.advert && window.advert.cmd || [];

window.advert = Object.assign({}, window.advert, {
	init,
	pubsub,
	cmd,
	'loadSlot': slotManager.loadSlot,
	'getSlot': slotManager.getSlot,
	'getSlots': slotManager.getSlots,
	'defineSlots': slotManager.defineSlots,
	'refreshSlots': adManager.refreshSlots,
	'getCurrentBreakpoint': breakpoints.getCurrentBreakpoint,
	'getSizeMapping': sizeMappings.getSizeMapping,
	'getSettings': () => settings,
	'updatePageTargeting': adManager.updatePageTargeting
});

cmd.setup(initialCmds, ['ready']);
